import React from "react";

const AddIcon = () => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M15.333 22.0002H16.6663V16.6668H21.9997V15.3335H16.6663V10.0002H15.333V15.3335H9.99967V16.6668H15.333V22.0002ZM7.48767 26.6668C6.87345 26.6668 6.36101 26.4615 5.95034 26.0508C5.53967 25.6402 5.3339 25.1273 5.33301 24.5122V7.48816C5.33301 6.87394 5.53879 6.3615 5.95034 5.95083C6.3619 5.54016 6.87434 5.33438 7.48767 5.3335H24.513C25.1263 5.3335 25.6388 5.53927 26.0503 5.95083C26.4619 6.36238 26.6672 6.87483 26.6663 7.48816V24.5135C26.6663 25.1268 26.461 25.6393 26.0503 26.0508C25.6397 26.4624 25.1268 26.6677 24.5117 26.6668H7.48767ZM7.48767 25.3335H24.513C24.7175 25.3335 24.9055 25.2482 25.077 25.0775C25.2486 24.9068 25.3339 24.7184 25.333 24.5122V7.48816C25.333 7.28283 25.2477 7.09438 25.077 6.92283C24.9063 6.75127 24.7179 6.66594 24.5117 6.66683H7.48767C7.28234 6.66683 7.0939 6.75216 6.92234 6.92283C6.75079 7.0935 6.66545 7.28194 6.66634 7.48816V24.5135C6.66634 24.7179 6.75167 24.9059 6.92234 25.0775C7.09301 25.2491 7.28101 25.3344 7.48634 25.3335"
                fill="#1E1E1E"
            />
        </svg>
    );
};

export default AddIcon;
